import React from "react";
import { styled } from "@mui/material/styles";

export const Root = styled("div")(({ theme }) => ({
  alignItems: "flex-start",
  display: "flex",
  marginTop: theme.shape.padding,
  paddingBottom: theme.shape.padding,
  flexWrap: "wrap",
  width: "100%",
}));

const ServerToolbar = ({ children }) => {
  return <Root>{children}</Root>;
};

export default ServerToolbar;
